import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { ServicesOverview } from "@/components/ServicesOverview";
import { NagayuSection } from "@/components/NagayuSection";
import { SelfWashPricing } from "@/components/SelfWashPricing";
import { GroomingBooking } from "@/components/GroomingBooking";
import { Gallery } from "@/components/Gallery";
import { ContactSection } from "@/components/ContactSection";
import { HolidayNotice } from "@/components/HolidayNotice";
import { MyBookingsDialog } from "@/components/MyBookingsDialog";
import { BoutiqueShowcase } from "@/components/BoutiqueShowcase";
import { ReviewsSection } from "@/components/ReviewsSection";
import { SitePopup } from "@/components/SitePopup";
import { Seo } from "@/components/Seo";
import { useLang } from "@/context/LanguageContext";

export default function Home() {
  const location = useLocation();
  const { t } = useLang();
  const [myBookingsPhone, setMyBookingsPhone] = useState(null);

  useEffect(() => {
    // Deep link from email/SMS: ?mybookings=69XXXXXXXX (or short ?m=) auto-opens the portal
    const params = new URLSearchParams(location.search);
    const p = params.get("mybookings") || params.get("m");
    if (p) {
      setMyBookingsPhone(p);
      // Clean URL so a refresh doesn't reopen the dialog
      window.history.replaceState({}, "", location.pathname + location.hash);
    }
  }, [location.search, location.pathname, location.hash]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [location.hash]);

  return (
    <div className="bg-background overflow-x-hidden">
      <Seo title={t.seo.home_title} description={t.seo.home_desc} path="/" />
      <Navbar />
      <main>
        <Hero />
        <About />
        <ServicesOverview />
        <BoutiqueShowcase />
        <NagayuSection />
        <SelfWashPricing />
        <GroomingBooking />
        <Gallery />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
      <HolidayNotice />
      <SitePopup />
      <MyBookingsDialog
        open={myBookingsPhone !== null}
        onOpenChange={(v) => { if (!v) setMyBookingsPhone(null); }}
        initialPhone={myBookingsPhone || ""}
      />
    </div>
  );
}
